import { render, staticRenderFns } from "./selectDocumentType.vue?vue&type=template&id=7e456479"
import script from "./selectDocumentType.vue?vue&type=script&lang=js"
export * from "./selectDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports